import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "forwardedAs"];
import React, { useContext } from 'react';
import Button from 'components/Button';
import { NavMenuContext } from './NavMenu';
function NavMenuButton(_ref) {
  var as = _ref.as,
    forwardedAs = _ref.forwardedAs,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(NavMenuContext),
    menuButtonProps = _useContext.menuButtonProps;
  var Component = as || Button;
  return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
    as: forwardedAs
  }, menuButtonProps));
}
export default NavMenuButton;